/**
 * Null-safe display helpers for loan credit metrics.
 *
 * Live records store ratios as decimal fractions (0.65) and may lack any
 * metric entirely; the demo dataset stores percent points (62.5). These
 * helpers normalize both and render '--' for absent values — a missing
 * metric must never crash a page or display as NaN.
 */

/** Normalize an LTV/debt-yield-style value to percent points, or null. */
export const pctPts = (v?: number | null): number | null =>
  v == null ? null : v <= 1 ? v * 100 : v

/** "62.5" (no % sign) or '--'. */
export const fmtPctCell = (v?: number | null, digits = 1): string => {
  const pts = pctPts(v)
  return pts == null ? '--' : pts.toFixed(digits)
}

/** "1.31x" or '--'. */
export const fmtDscr = (v?: number | null): string =>
  v != null && v > 0 ? `${v.toFixed(2)}x` : '--'
